(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function(){
  function updateCartCount(){
    fetch('/cart.js')
      .then(r => r.json())
      .then(data => {
        var bubble = document.querySelector('.hc-cart-bubble');
        if(!bubble) return;
        var count = data.item_count || 0;
        bubble.textContent = count;
        bubble.style.display = count > 0 ? 'inline-grid' : 'none';
      });
  }
  document.addEventListener('DOMContentLoaded', updateCartCount);
})();

document.addEventListener('DOMContentLoaded', function () {
  const ham = document.querySelector('.hc-hamburger');
  const mobileNav = document.querySelector('.hc-mobile-nav');
  const closeBtn = document.querySelector('.hc-mobile-close');

  if (ham && mobileNav) {
    ham.addEventListener('click', () => {
      mobileNav.classList.add('active');
      ham.classList.add('active');
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      mobileNav.classList.remove('active');
      ham.classList.remove('active');
    });
  }
});

// Mobile submenu open/close
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".hc-mobile-parent").forEach(btn => {
    btn.addEventListener("click", function () {
      const submenu = btn.nextElementSibling;
      submenu.style.display = submenu.style.display === "block" ? "none" : "block";
      btn.classList.toggle("open");
    });
  });
});

document.addEventListener("DOMContentLoaded", function() {
    const searchBtn = document.querySelector(".search-action");
    if(searchBtn){
        searchBtn.addEventListener("click", function(){
            document.dispatchEvent(new CustomEvent("theme:search:open"));
        });
    }
});
/* =========================
   SALE TIMER
========================= */
/* =========================
   SALE TIMER (Noon 12 → Night 12)
========================= */

function updateSaleTimer() {

    const now = new Date();

    // Target: aaj raat 12:00 baje (midnight)
    let target = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1,
        0, 0, 0
    );

    const diff = target - now;

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    document.getElementById("sale-hours").innerText =
        String(hours).padStart(2, '0');

    document.getElementById("sale-minutes").innerText =
        String(minutes).padStart(2, '0');

    document.getElementById("sale-seconds").innerText =
        String(seconds).padStart(2, '0');
}

updateSaleTimer();

setInterval(updateSaleTimer, 1000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
